module.exports = __webpack_public_path__ + "img/zimg9.96f1a38d.png";